"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnaccFixedComponentFundingRateDto {
}
exports.AnaccFixedComponentFundingRateDto = AnaccFixedComponentFundingRateDto;
